import { Component } from '@angular/core';
import { takeUntil } from 'rxjs';
import {
  aboutTrx,
  arcadeTrx,
  clientAreaMainTrx,
  clientAreaTrx,
  desktopTrx,
  gameInfoTrx,
  gameTrx,
  highFlyerTrx,
  liveCasinoTrx,
  lostPasswordTrx,
  plinkoLuckeraTrx,
  promotionsTrx,
  providerTrx,
  termsTrx,
  topMenuGameTrx
} from 'src/app/router-translation.labels';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { BasePageComponent } from '../../base-page/base-page.component';
import { HidePromotionsService } from 'src/app/services/utils/hide-promotions.service';
import { LicenceService } from 'src/app/services/utils/licence.service';


@Component({
  selector: 'app-desktop-top-menu',
  templateUrl: './desktop-top-menu.component.html',
  styleUrls: ['./desktop-top-menu.component.scss']
})
export class DesktopTopMenuComponent extends BasePageComponent {

  constructor(
    protected loginStatus: LoginStatusService,
    protected translationConfig: TranslationConfig,
    public minimizeSiteService: MinimizeSiteService,
    public bannerService: HidePromotionsService,
    protected licenceService: LicenceService,

  ) { super() }

  isLogin: boolean = false;
  isBannerExist: boolean = false;

  lostPasswordTrx = this.translationConfig.getTranslation(lostPasswordTrx);
  aboutTrx: string = this.translationConfig.getTranslation(aboutTrx);
  termsTrx: string = this.translationConfig.getTranslation(termsTrx);
  promotionsTrx: string = this.translationConfig.getTranslation(promotionsTrx);
  prifileTrx: string = this.translationConfig.getTranslation(clientAreaTrx) + '/' + this.translationConfig.getTranslation(clientAreaMainTrx)
  liveCasinoUrl: string = this.translationConfig.getTranslation(liveCasinoTrx);
  arcadeUrl: string = this.translationConfig.getTranslation(gameTrx) + '/' + this.translationConfig.getTranslation(arcadeTrx);
  gameUrl:string = this.translationConfig.getTranslation(gameInfoTrx) + '/' + this.translationConfig.getTranslation(topMenuGameTrx);
  highFlyerUrl:string = this.translationConfig.getTranslation(gameInfoTrx) + '/' + this.translationConfig.getTranslation(highFlyerTrx);
  plinkoUrl:string = this.translationConfig.getTranslation(gameTrx)+'/'+this.translationConfig.getTranslation(plinkoLuckeraTrx);
  slots: string = this.translationConfig.getTranslation(gameTrx);
  isInGame: boolean = false;
  desktopTrx = this.translationConfig.getTranslation(desktopTrx);
  providerTrx = this.translationConfig.getTranslation(providerTrx);

  ngOnInit(): void {
    this.loginStatus.getLoginStatus().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      this.isLogin = resp.isLogged === LoggedStatus.logged ? true : false;
    })

    this.minimizeSiteService.isRegularPage().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      this.isInGame = resp;
    })

    this.bannerService.isBannerExist().pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      this.isBannerExist = res;
    })

  }

  toggleBanner() {
    this.bannerService.toggleShowBanner();
  }

}
